import { render, staticRenderFns } from "./portfolioFullwidth.vue?vue&type=template&id=4a46d392&"
import script from "./portfolioFullwidth.vue?vue&type=script&lang=js&"
export * from "./portfolioFullwidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports